import { render, staticRenderFns } from "./NaviGation_Video.vue?vue&type=template&id=327a7d8e&scoped=true"
import script from "./NaviGation_Video.vue?vue&type=script&lang=js"
export * from "./NaviGation_Video.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_Video.vue?vue&type=style&index=0&id=327a7d8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a7d8e",
  null
  
)

export default component.exports